import {
  DoorOpen, LogOut as LogOutIcon, Wifi, Home, ScrollText, Car,
  UtensilsCrossed, TramFront, Siren, MessageCircle, Sparkles,
} from "lucide-react";

// Guest guide section metadata: icon + professional titles/subtitles (EN/IT)
export const SECTION_META = {
  welcome: { icon: Sparkles, en: "Welcome", it: "Benvenuti", subEn: "Start your stay here", subIt: "Inizia il tuo soggiorno" },
  checkin: { icon: DoorOpen, en: "Check-in", it: "Check-in", subEn: "Everything you need to arrive", subIt: "Tutto per il tuo arrivo" },
  checkout: { icon: LogOutIcon, en: "Check-out", it: "Check-out", subEn: "How to leave the property", subIt: "Come lasciare l'alloggio" },
  wifi: { icon: Wifi, en: "Wi-Fi", it: "Wi-Fi", subEn: "Connect in one tap", subIt: "Connettiti con un tocco" },
  house_guide: { icon: Home, en: "House Amenities", it: "Servizi della Casa", subEn: "How everything works", subIt: "Come funziona tutto" },
  house_rules: { icon: ScrollText, en: "House Rules", it: "Regole della Casa", subEn: "A few things to keep in mind", subIt: "Alcune cose da ricordare" },
  parking: { icon: Car, en: "Parking", it: "Parcheggio", subEn: "Where and how to park", subIt: "Dove e come parcheggiare" },
  local_guide: { icon: UtensilsCrossed, en: "Local Tips", it: "Consigli Locali", subEn: "Our favourite places nearby", subIt: "I nostri posti preferiti" },
  getting_around: { icon: TramFront, en: "Getting Around", it: "Come Muoversi", subEn: "Transport and directions", subIt: "Trasporti e indicazioni" },
  emergency: { icon: Siren, en: "Emergency", it: "Emergenze", subEn: "Important numbers and info", subIt: "Numeri e info importanti" },
  contact: { icon: MessageCircle, en: "Contact Host", it: "Contatta l'Host", subEn: "Need help? Reach your host", subIt: "Serve aiuto? Contatta l'host" },
};

export const LOCAL_CATEGORIES = [
  "Restaurant", "Bar", "Café", "Supermarket", "Attraction",
  "Public Transport", "Beach", "Parking", "Shopping", "Other",
];

export const APPLIANCE_PRESETS = [
  "Air Conditioning", "Heating", "Television", "Washing Machine",
  "Dishwasher", "Coffee Machine", "Oven", "Stove", "Other",
];

// Guest-guide visual themes (templates). `dark` flips text colours.
export const GUIDE_THEMES = {
  minimal: { label: "Minimal", bg: "#FFFFFF", surface: "#FFFFFF", border: "#ECECEC", text: "#111827", muted: "#8A8F98", accent: "#111827", heading: "display", dark: false,
    img: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  luxury: { label: "Luxury", bg: "#111114", surface: "#1B1B1F", border: "#2A2A2F", text: "#F5F3EF", muted: "#A8A29A", accent: "#C9A96A", heading: "serif", dark: true,
    img: "https://images.unsplash.com/photo-1640357897497-599b4fc84f51?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  mediterranean: { label: "Mediterranean", bg: "#FDFBF7", surface: "#FFFFFF", border: "#F0EDE6", text: "#1F2A44", muted: "#7A736A", accent: "#2E7CB8", heading: "serif", dark: false,
    img: "https://images.unsplash.com/photo-1505577058444-a3dab90d4253?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  urban: { label: "Urban", bg: "#F5F5F4", surface: "#FFFFFF", border: "#E7E5E4", text: "#1C1917", muted: "#78716C", accent: "#0EA5A0", heading: "display", dark: false,
    img: "https://images.unsplash.com/photo-1505873242700-f289a29e1e0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  family: { label: "Family", bg: "#FEF8F1", surface: "#FFFFFF", border: "#F5E8D8", text: "#42302B", muted: "#9A8478", accent: "#E8894A", heading: "serif", dark: false,
    img: "https://images.unsplash.com/photo-1641232458416-feace752b346?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  nature: { label: "Nature", bg: "#F3F6F1", surface: "#FFFFFF", border: "#E1EADD", text: "#26382B", muted: "#748A78", accent: "#3F7A54", heading: "serif", dark: false,
    img: "https://images.unsplash.com/photo-1449158743715-0a90ebb6d2d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
};

export function themeTokens(themeKey, brandColor) {
  const base = GUIDE_THEMES[themeKey] || GUIDE_THEMES.mediterranean;
  return { ...base, accent: brandColor || base.accent };
}

export const BRAND_COLORS = ["#1E3A5F", "#2E7CB8", "#DC4C3E", "#F5A623", "#0EA5A0", "#3F7A54", "#C9A96A", "#8B5CF6"];
